import type { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import type { UpsellBlock } from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

type UpsellGlpRow = NonNullable<UpsellBlock['glpRow']>

interface GlpRowBlockProps {
  block: UpsellGlpRow
}

const MediaBox = ({ src }: { src: string | null | undefined }) => {
  const isVideo = src?.match(/\.(mp4|webm|ogg|mov|avi)$/i)

  return (
    <Box borderRadius={{ all: 'abs016' }} overflowX="hidden" className="w-full md:w-1/2">
      {isVideo ? (
        <video
          src={src || ''}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '280px',
            display: 'block',
            borderRadius: '14px',
          }}
          autoPlay
          muted
          loop
        />
      ) : (
        <img
          src={src || ''}
          alt=""
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '280px',
            display: 'block',
            borderRadius: '14px',
          }}
        />
      )}
    </Box>
  )
}

const TextBox = ({ block }: Pick<GlpRowBlockProps, 'block'>) => (
  <Box
    gap="s16"
    className="w-full md:w-[30%] px-6"
    alignItems="flexStart"
    padding="s40"
    maxWidth="s600"
  >
    {block.rowTitle && (
      <Text size="400" weight="semibold" color="black">
        {block.rowTitle || ''}
      </Text>
    )}
    {block.rowContent && <Text size="300">{block.rowContent || ''}</Text>}
    {block.actions &&
      block.actions.map((action) => (
        <F0Button
          key={action?.id}
          label={action?.label}
          variant={action?.style == 'primary_btn' ? 'default' : 'outline'}
          onClick={() => {
            track(trackingEvents.discover.clickGlpButton, {
              component: 'glp_row',
              action: action.label || '',
            })
            if (action?.opensInNewTab && action?.url) {
              window.open(action.url, '_blank')
            } else if (action?.url) {
              window.location.href = action.url
            }
          }}
        />
      ))}
  </Box>
)

export const GlpRowBlock: FC<GlpRowBlockProps> = ({ block }) => {
  if (!block) {
    return null
  }

  const positionIsRight = block?.mediaPosition === 'true'
  return (
    <Box flexDirection="row" gap="s16">
      {positionIsRight ? (
        <>
          <MediaBox src={block?.rowMedia?.url ?? null} />
          <TextBox block={block} />
        </>
      ) : (
        <>
          <TextBox block={block} />
          <MediaBox src={block?.rowMedia?.url ?? null} />
        </>
      )}
    </Box>
  )
}
